import { Checkbox, Flex, Stack, Text } from '@chakra-ui/react';
import { shallow } from 'zustand/shallow';
import { useUIStore } from '#store';

/**
 * Single-select permit modes from `outing.permitModes` (e.g. Inyo). Uses `trackerInput.filters.permitModes`.
 */
export default function PermitModeSelector({ stackSpacing = 3, mb = 4 } = {}) {
  const {
    outing,
    trackerInput: { filters },
    setPermitModeFilter,
  } = useUIStore(
    (state) => ({
      outing: state.outing,
      trackerInput: state.trackerInput,
      setPermitModeFilter: state.setPermitModeFilter,
    }),
    shallow
  );
  const modes = outing?.permitModes;
  if (!modes?.length) return null;
  const selected = filters.permitModes?.[0];
  return (
    <Stack spacing={stackSpacing} mb={mb}>
      <Text fontWeight="600" fontSize="sm" color="brand.900">
        Permit type
      </Text>
      <Flex
        direction={{ base: 'column', sm: 'row' }}
        gap={{ base: 2, sm: 6 }}
        flexWrap="wrap"
        align="flex-start"
      >
        {modes.map((mode) => (
          <Checkbox
            key={mode}
            colorScheme="brand"
            isChecked={selected === mode}
            onChange={() => setPermitModeFilter(mode)}
          >
            <Text color="brand.900" fontWeight={500} fontSize="0.9em">
              {mode}
            </Text>
          </Checkbox>
        ))}
      </Flex>
    </Stack>
  );
}
